import { DisplayFormat, FetchStatus, Property, PropertyType } from "../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../base/hooks";
import { useEffect, useState } from "react";

import { IHeadingProps } from "./IHeadingProps";
import { IProperty } from "../../../../base/models";
import { formatValue } from "../../../helpers";

export const HeadingProperties: IProperty[] = [
    { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    { id: Property.Heading, name: 'Heading', type: PropertyType.String },
    { id: Property.Format, name: 'Display Format', type: PropertyType.DisplayFormat },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
]

export const useHeadingProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IHeadingProps>()
    const draftText = usePropertyDraftText({bindings, property: Property.Heading})

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const textValue = bindings.getValue<string>(Property.Heading);
        const format = bindings.getValue<DisplayFormat>(Property.Format);
        const heading = formatValue(textValue, format)
        const title = bindings.getValue<string>(Property.Tooltip);
        const icon = bindings.getValue<string>(Property.MaterialIcon);

        setProperties({ heading, title, icon })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
